const API_URL = import.meta.env.VITE_API_URL || 'https://email-service-bun-production.up.railway.app';

interface SubmissionResponse {
  success: boolean;
  id?: string;
  error?: string;
  message?: string;
}

/**
 * Submit data to Sanity via the API
 * @param type - The Sanity document type (e.g., 'contactSubmission', 'supplierSubmission')
 * @param data - The data to submit
 * @returns Promise with the API response
 */
export async function submitToSanity(
  type: string,
  data: Record<string, any>
): Promise<SubmissionResponse> {
  try {
    const response = await fetch(`${API_URL}/api/mutate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        _type: type,
        ...data,
      }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Submission failed');
    }

    return result;
  } catch (error) {
    console.error('Submission error:', error);
    throw error;
  }
}
